import { getProfessionalInfo, getProfessionalSelf,getProfessionalHospital,getProfessionalDepoartment,getTodayBooking,getPatient_Check,getAiReference,postAiRecord } from "./newpost";
import { getLoginuserId ,getLoginuserDepart, getDepoartmentId, getUsername} from "./newdeal";

import { setProfessionalSelf,listOfPatientConversation,addOfPatientConversation,listOfPatientMedicalRecord } from "./newpost";


export async function getLoginUserDepart() { 
    const resp = await getProfessionalInfo({
        id: getLoginuserId()
    });
    
    return resp;
     
}


export async function getLoginUserSelf() { 
    const resp = await getProfessionalSelf({
        id: getLoginuserId()
    });
    
    return resp;
     
}


//所属医院
export async function getLoginUserHospital() { 
    const resp = await getProfessionalHospital({
        sysOrgCode: getLoginuserDepart()
    });
    
    return resp;
     
}

//所属科室
export async function getLoginUserDepoartment() { 
    const resp = await getProfessionalDepoartment({
        subId: getDepoartmentId ()
    });
    
    return resp;
     
}


//今日挂号列表
export async function getLoginuserTodayBooking() {
    const resp = await getTodayBooking({
        professionalId: getUsername (),
        registrationTime:"",
        departmentId:getDepoartmentId()
    });    
    return resp;     
}

//某个患者的 检查记录列表
export async function getPatient_CheckList(patientId) {
    const resp = await getPatient_Check({
        medmstrId: patientId
         
    });    
    return resp;     
}

//个人设置-常用问题-读取
export async function getProfessional_Self(id) {
    const resp = await getProfessionalSelf({
        id: id
         
    });    
    return resp;     
}

//个人设置-常用问题-写入
export async function setProfessional_Self(id) {
    const resp = await setProfessionalSelf({
        id: id         
    });    
    return resp;     
}


//AI 引用
export async function getAi_Reference(chatId,content) {
    const resp = await getAiReference({
        chatId: chatId,
        content: content
    });    
    return resp;     
}



//AI 引用
export async function postAi_Record(file) {

    const result = await postAiRecord(file);
    return result;     
}


//添加AI会话
export async function addConversation_Record(data) {
    const resp = await addOfPatientConversation({
         
        
    });    
    const result = await addOfPatientConversation(resp);
    return result;     
}